/**
 * Add date tokens to the string
 * @param text - text template - available tokens:
 * [year] - current year
 * [month] - month
 * [day] - short date
 * @param date - date string
 **/

// TODO - add more tokes support
export const withDate = (text?: string, date?: string) => {
  const dateObject = date ? new Date(date) : new Date();
  const year = dateObject.getFullYear().toString();
  return text?.replaceAll('[year]', year);
};

/**
 * Display short date
 */
export const shortDate = (dateString: string | undefined | null, appendYear?: boolean) => {
  if (!dateString) {
    return '';
  }
  let date;
  try {
    date = new Date(dateString);
  } catch {
    console.log('Wrong date string', dateString);
  }
  const dateFormatter = new Intl.DateTimeFormat('no-NB', {
    // Set the desired date format
    day: 'numeric',
    month: 'long',
    year: appendYear ? 'numeric' : undefined,
  });
  return dateFormatter.format(date);
};

/**
 * Display long date
 */
export const longDate = (dateString: string | undefined | null) => {
  if (!dateString) {
    return '';
  }
  let date;
  try {
    date = new Date(dateString);
  } catch {
    console.log('Wrong date string', dateString);
  }
  // TODO [KF][AS] - need to decide and implement how we can read locale on Front End
  const dateFormatter = new Intl.DateTimeFormat('no-NB', {
    // Set the desired date format
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  return dateFormatter.format(date);
};

/**
 * Display full date and time
 */
export const fullDateAndTime = (dateString: string | undefined | null) => {
  if (!dateString) {
    return '';
  }
  let date;
  try {
    date = new Date(dateString);
  } catch {
    console.log('Wrong date string', dateString);
  }
  const dateFormatter = new Intl.DateTimeFormat('no-NB', {
    // Set the desired date format
    day: 'numeric',
    month: 'short',
    minute: '2-digit',
    hour: '2-digit',
    year: '2-digit',
    second: '2-digit',
  });
  return dateFormatter.format(date);
};

export const formatDateRange = (startDateString?: string, endDateString?: string) => {
  // If both dates are missing, return empty string
  if (!startDateString && !endDateString) {
    return '';
  }
  // If one date is missing, return full date with year
  if (!startDateString) {
    return shortDate(endDateString, true);
  }
  if (!endDateString) {
    return shortDate(startDateString, true);
  }

  const startDate = new Date(startDateString);
  const endDate = new Date(endDateString);

  // Both Start and End is the same day - return only one with full year
  if (isSameDay(startDate, endDate)) {
    return shortDate(startDateString, true);
  }

  const appendYear = startDate.getFullYear() !== endDate.getFullYear();
  if (startDate > endDate) {
    console.log('Start date should not be set before end date');
    return '';
  }
  return `${shortDate(startDateString, appendYear)} - ${shortDate(endDateString, appendYear)}`;
};

/**
 * Check if two dates are same day
 */
export const isSameDay = (date1: Date, date2: Date) => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};
